"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_dom_1 = require("react-dom");
const context_1 = require("./context");
const PortalState_1 = require("./PortalState");
const context_2 = require("../../context");
const ScopedResetContext_1 = require("../../context/ScopedResetContext");
const useIsomorphicLayoutEffect_1 = tslib_1.__importDefault(require("react-use/lib/useIsomorphicLayoutEffect"));
const Portal = ({ children, parent, className }) => {
    const parentState = (0, context_1.usePortal)();
    const defaultParent = (0, context_1.usePortalParent)();
    const scopedResetClass = (0, ScopedResetContext_1.useScopedResetClass)();
    const state = React.useMemo(() => {
        const state = new PortalState_1.PortalState();
        state.parent = parentState;
        return state;
    }, [parentState]);
    const [el] = React.useState(() => document.createElement('div'));
    const hidden = (0, context_2.useHiddenTrace)();
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        const style = el.style;
        if (style.display !== 'none' && hidden)
            style.display = 'none';
        else if (style.display === 'none' && !hidden)
            style.display = '';
    }, [hidden, el]);
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        const next = [scopedResetClass, className].filter(Boolean).join(' ');
        if (el.className !== next)
            el.className = next;
    }, [el, scopedResetClass, className]);
    React.useLayoutEffect(() => {
        const container = parent || defaultParent || document.body;
        container.appendChild(el);
        state.addRoot(el);
        return () => {
            try {
                state.delRoot(el);
                container.removeChild(el);
            }
            catch { }
        };
    }, [parent, defaultParent, el, state.addRoot, state.delRoot]);
    return React.createElement(context_1.context.Provider, { value: state }, (0, react_dom_1.createPortal)(children, el));
};
exports.Portal = Portal;
